import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

// TODO: track down where this is triggered from

const defaultData: IDataLayer = {
  sppOpenPostmatesOverlay: {
    event_name: 'delivery_options',
    event_category: 'delivery options',
    event_action: 'launched',
    event_label: 'postmates',
  },

  cartPostamatesStatus: {
    event_name: 'checkout_option',
    event_category: 'ecommerce',
    event_action: 'same day delivery banner',
    event_label: null, // '<selected delivery type>'
  },
};

function trackPostmates(eventName: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackPostmates);
});
